<template>
  <div class="max-w-[2560px] mx-auto">
    <div v-if="companyInfo.length > 0">
      <hr />
      <footer
        class="bg-tbt-blue text-white border-t md:py-[30px] lg:px-[100px] footer-p text-[16px] lg:text-[18px]"
      >
        <div
          class="mx-auto py-10 px-4 lg:px-0 grid grid-cols-1 lg:grid-cols-2 gap-8"
        >
          <!-- Left Column -->
          <div>
            <div class="flex items-center space-x-3">
              <img
                :src="companyInfo[0].secondary_logo_path"
                alt="Logo"
                class="w-10 h-10 rounded-full"
              />
              <h2 class="font-semibold text-[15px] lg:text-[16px]">
                {{ getLocalized(companyInfo[0], "name") }}
              </h2>
            </div>
            <p class="md:mt-4 text-[15px] lg:text-[16px]">
              {{ getLocalized(companyInfo[0], "tagline") }}
            </p>
            <div class="mt-4">
              <div
                class="flex items-center space-x-3 text-[15px] lg:text-[16px]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.5rem"
                  height="1.5rem"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m16.1 13.359l-.528-.532zm.456-.453l.529.532zm2.417-.317l-.358.66zm1.91 1.039l-.358.659zm.539 3.255l.529.532zm-1.42 1.412l-.53-.531zm-1.326.67l.07.747zm-9.86-4.238l.528-.532zM4.002 5.746l-.749.042zm6.474 1.451l.53.532zm.157-2.654l.6-.449zM9.374 2.86l-.601.45zM6.26 2.575l.53.532zm-1.57 1.56l-.528-.531zm7.372 7.362l.529-.532zm4.567 2.394l.455-.453l-1.058-1.064l-.455.453zm1.985-.643l1.91 1.039l.716-1.318l-1.91-1.038zm2.278 3.103l-1.42 1.413l1.057 1.063l1.42-1.412zm-2.286 1.867c-1.45.136-5.201.015-9.263-4.023l-1.057 1.063c4.432 4.407 8.65 4.623 10.459 4.454zm-9.263-4.023c-3.871-3.85-4.512-7.087-4.592-8.492l-1.498.085c.1 1.768.895 5.356 5.033 9.47zm1.376-6.18l.286-.286L9.95 6.666l-.287.285zm.515-3.921L9.974 2.41l-1.201.899l1.26 1.684zM5.733 2.043l-1.57 1.56l1.058 1.064l1.57-1.56zm4.458 5.44c-.53-.532-.53-.532-.53-.53h-.002l-.003.004a1 1 0 0 0-.127.157c-.054.08-.113.185-.163.318a2.1 2.1 0 0 0-.088 1.071c.134.865.73 2.008 2.256 3.526l1.058-1.064c-1.429-1.42-1.769-2.284-1.832-2.692c-.03-.194.001-.29.01-.312q.009-.02 0-.006a.3.3 0 0 1-.03.039l-.01.01l-.01.009zm1.343 4.546c1.527 1.518 2.676 2.11 3.542 2.242c.443.068.8.014 1.071-.087a1.5 1.5 0 0 0 .42-.236l.05-.045l.007-.006l.003-.003l.001-.002s.002-.001-.527-.533c-.53-.532-.528-.533-.528-.533l.002-.002l.002-.002l.006-.005l.01-.01l.038-.03q.014-.009-.007.002c-.025.009-.123.04-.32.01c-.414-.064-1.284-.404-2.712-1.824zm-1.56-9.62C8.954 1.049 6.95.834 5.733 2.044L6.79 3.107c.532-.529 1.476-.475 1.983.202zM4.752 5.704c-.02-.346.139-.708.469-1.036L4.163 3.604c-.537.534-.96 1.29-.909 2.184zm14.72 12.06c-.274.274-.57.428-.865.455l.139 1.494c.735-.069 1.336-.44 1.784-.885zM11.006 7.73c.985-.979 1.058-2.527.229-3.635l-1.201.899c.403.539.343 1.246-.085 1.673zm9.52 6.558c.817.444.944 1.49.367 2.064l1.058 1.064c1.34-1.333.927-3.557-.71-4.446zm-3.441-.849c.384-.382 1.002-.476 1.53-.19l.716-1.317c-1.084-.59-2.428-.427-3.304.443z"
                  />
                </svg>
                <span class="text-[15px] lg:text-[16px]">{{
                  companyInfo[0].primary_phone
                }}</span>
              </div>
              <div
                class="flex items-center space-x-3 mt-2 text-[15px] lg:text-[16px]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.5rem"
                  height="1.5rem"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill="currentColor"
                    d="M15.5 4A2.5 2.5 0 0 1 18 6.5v8a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 14.5v-8A2.5 2.5 0 0 1 4.5 4zM17 7.961l-6.746 3.97a.5.5 0 0 1-.426.038l-.082-.038L3 7.963V14.5A1.5 1.5 0 0 0 4.5 16h11a1.5 1.5 0 0 0 1.5-1.5zM15.5 5h-11A1.5 1.5 0 0 0 3 6.5v.302l7 4.118l7-4.12v-.3A1.5 1.5 0 0 0 15.5 5"
                  />
                </svg>
                <span>{{ companyInfo[0].email }}</span>
              </div>
              <div class="flex items-start space-x-3 mt-2 text-white">
                <img src="../assets/pictures/LocationFooter.svg" alt="" />
                <h1 class="w-[280px] h-[90px] text-[15px] lg:text-[16px]">
                  {{ getLocalized(companyInfo[0], "address") }}
                </h1>
              </div>
            </div>
          </div>

          <!-- Middle Column -->
          <div class="grid gap-8 lg:flex lg:justify-between">
            <div class="hidden md:block">
              <h3 class="font-semibold mb-4">
                {{ getLocalized1("service") }}
              </h3>
              <ul class="space-y-2 text-[15px] lg:text-[16px]">
                <li v-for="item in subMenu" :key="item.url">
                  <a :href="item.url">{{ getLocalized(item, "name") }}</a>
                </li>
              </ul>
            </div>
            <div>
              <h3 class="font-semibold mb-4">
                {{ getLocalized1("company") }}
              </h3>
              <ul class="space-y-2 text-[15px] lg:text-[16px">
                <!-- Display footerInfo items -->
                <li
                  v-for="item in footerInfo"
                  :key="item.display_order"
                  class="hidden md:block"
                >
                  <a :href="item.url">{{ getLocalized(item, "name") }}</a>
                </li>
                <!-- Conditionally display "Our Services" for mobile -->
                <li
                  v-for="item in mobileFooter"
                  :key="item.url"
                  class="md:hidden"
                >
                  <a :href="item.url">{{ getLocalized(item, "name") }}</a>
                </li>
              </ul>
            </div>

            <!-- Right Column -->
            <div>
              <h3 class="font-semibold mb-4">
                {{ getLocalized1("socialMedia") }}
              </h3>

              <div class="flex space-x-2">
                <span v-for="item in socialMedia" :key="item.url">
                  <a :href="item.url" target="_blank">
                    <img
                      class="responsive-image"
                      :src="item.icon_path"
                      :alt="item.platform_name"
                    />
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Line Separator -->
        <hr class="mb-4 w-full mx-auto lg:px-[100px]" />

        <!-- Footer Bottom Section -->
        <div
          class="mx-auto flex flex-col md:flex-row items-center justify-between"
        >
          <!-- Left-aligned Copyright -->
          <div class="px-4 lg:px-0 text-left text-[12px]">
            <p v-html="getLocalized1('copyright')"></p>
          </div>

          <!-- Right-aligned Links -->
          <div class="text-right space-x-6">
            <!-- <a href="#" class="hover:underline">Privacy Policy</a>
            <a href="#" class="hover:underline">Terms of Service</a> -->
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useLocalization } from "../composable/useLocalization";

export default {
  data() {
    return {
      companyInfo: [],
      api: process.env.VUE_APP_API_KEY,
      socialMedia: [],
      footerInfo: [],
      mobileFooter: [],
      subMenu: [],
      translations: {
        service: {
          en: "Our Services",
          kh: "សេវាកម្មរបស់យើង",
        },
        company: {
          en: "About Company",
          kh: "អំពីក្រុមហ៊ុន",
        },
        socialMedia: {
          en: "Our Social Media",
          kh: "ប្រព័ន្ធផ្សព្វផ្សាយសង្គមរបស់យើង",
        },
        copyright: {
          en: "Copyright &copy; 2024 TURBOTECH Co., Ltd",
          kh: "រក្សាសិទ្ធគ្រប់យ៉ាងដោយ ក្រុមហ៊ុន​ធើបូថេក ឯ.ក",
        },
      },
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
    getLocalized1() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },
  mounted() {
    this.fetchCompanyInfo();
  },
  methods: {
    async fetchCompanyInfo() {
      try {
        const response = await axios.get(this.api + "/api/company-info");
        this.companyInfo = response.data.items;
        this.companyInfo = this.companyInfo.map((item) => ({
          ...item,
          secondary_logo_path: `${this.api}${item.secondary_logo_path}`,
          logo_path: `${this.api}${item.logo_path}`,
        }));

        const responseMedia = await axios.get(this.api + "/api/social-media/");
        this.socialMedia = responseMedia.data.items;
        this.socialMedia = this.socialMedia
          .map((item) => ({
            ...item,
            icon_path: `${this.api}${item.icon_path}`,
          }))
          .sort((a, b) => a.display_order - b.display_order);

        const responseRoute = await axios.get(this.api + "/api/menus");
        this.footerInfo = responseRoute.data.items;
        this.footerInfo = this.footerInfo
          .filter(
            (item) => item.name_en !== "Our Services" && item.name_en !== "Home"
          )
          .sort((a, b) => {
            if (a.name_en === "About Us") return -1;
            if (b.name_en === "About Us") return 1;
            if (a.name_en === "Contact Us") return -1;
            if (b.name_en === "Contact Us") return 1;
            return a.display_order - b.display_order;
          });

        this.mobileFooter = responseRoute.data.items;

        this.mobileFooter = this.mobileFooter
          .filter((item) => item.name_en !== "Home")
          .sort((a, b) => {
            if (a.name_en === "About Us") return -1;
            if (b.name_en === "About Us") return 1;
            if (a.name_en === "Contact Us") return -1;
            if (b.name_en === "Contact Us") return 1;
            return a.display_order - b.display_order;
          });

        const responseSubMenu = await axios.get(this.api + "/api/submenus");
        this.subMenu = responseSubMenu.data.items;
      } catch (e) {
        console.error(e.message);
      }
    },
  },
};
</script>

<style scoped>
@media (min-width: 1100px) and (max-width: 1200px) {
  .responsive-image {
    width: 24px;
    height: 24px;
  }
  .footer-p {
    padding: 80px;
  }
}
</style>
